<template>
    <div
        class="menu_language"
        v-if="
            App.root_activated_view === 'dashboard' ||
            App.root_activated_view === 'login'
        "
    >
        <div class="custom_select">
            <span @click="menuLangListItemsShow">
                <label v-bind:class="{ custom_select_open: list_item_show }">{{
                    languages[current_language]
                }}</label>
                <i
                    v-bind:class="{ custom_select_open: list_item_show }"
                    class="icon-chevron-up"
                ></i>
            </span>
            <ul v-bind:class="{ custom_select_open: list_item_show }">
                <li
                    @click="setLanguage(lang_key)"
                    v-for="(lang, lang_key) in languages"
                    :key="lang_key"
                    :class="[{ selected: languages[current_language] == lang }]"
                >
                    <span class="item_1">{{ lang }}</span>
                    <span class="item_2">{{ lang_key }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import App from './../application.js'

export default {
    data: function () {
        var current_language;
        if (this.$root != undefined && this.$root.$data.App != undefined) {
            current_language = this.$root.$data.App.selected_language
        } else {
            current_language = App.selected_language;
        }
        var obj = {
            languages: App.current_translations['languages'],
            current_language: current_language,
            list_item_show: false,
            App: App
        };
        this.filterLanguages(obj);
        return obj;
    },
    methods: {
        setLanguage: function (lang_key) {
            if (App.root_activated_view == 'login') {
                App.setLanguage(lang_key);
                this.current_language = lang_key;
                this.filterLanguages(this);
            } else {
                App.unex_lib.setLanguage(lang_key);
                App.unex_lib.setLanguageSolutions(lang_key);
                App.unex_lib.setDefaultLanguage(lang_key);
                App.unex_lib.setDefaultLanguageSolutions(lang_key);
                this.current_language = lang_key;
                App.setLanguage(lang_key);
                this.filterLanguages(this);

                sessionStorage.unex_lib = null;
                sessionStorage.unex_lib = JSON.stringify(App.unex_lib);
            }

            this.list_item_show = false;
            if (typeof unex_lib == 'undefined') {
                return;
            }

            App.bus.$emit('saveChangeLanguageApp');
        },
        menuLangListItemsShow: function () {
            this.list_item_show = this.list_item_show == false;
        },

        filterLanguages(obj) {
            if (typeof App.unex_lib == 'undefined') {
                return;
            }
            var avaliable_langs = obj.languages;
            var avaliable_user_langs = App.user.languages;
            for (var i in avaliable_langs) {
                if (avaliable_user_langs.indexOf(i) === -1) {
                    delete avaliable_langs[i];
                }
            }
            obj.languages = avaliable_langs;
        }
    },
    mounted: function () {
        var self = this;
        App.bus.$on('in_dashboard', function () {
            self.filterLanguages(self);
        });
        if (self.$root.$data.root_activated_view != 'login') {
            self.current_language = App.selected_language_solutions;
            App.setLanguage(App.selected_language_solutions);
        }
        App.bus.$on('onChangeModalLanguage', function () {
            sessionStorage.unex_lib = null;
            sessionStorage.unex_lib = JSON.stringify(App.unex_lib);
            self.current_language = App.selected_language;
            App.bus.$emit('hide_loader', 'menu_lang');
        });

        this.filterLanguages(self);
    },
    updated: function () {
        this.filterLanguages(this);
    }
}
</script>

<style>
</style>